import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Chameleon reducer is used to track information that
// must be accessed across components in order to send
// chameleon events

export interface ChameleonReducer {
  createdVmId: string
  migratedVmIds: string[]
  createdVolumeId: string
}

export const defaultState: ChameleonReducer = {
  createdVmId: null,
  migratedVmIds: [],
  createdVolumeId: null,
}

type UpdateAction = Partial<ChameleonReducer>

const {
  name: chameleonKey,
  reducer: chameleonReducer,
  actions: chameleonActions,
} = createSlice({
  name: 'chameleon',
  initialState: defaultState,
  reducers: {
    updateChameleonState: (state, { payload }: PayloadAction<UpdateAction>) => {
      return { ...state, ...payload }
    },
  },
})

export { chameleonActions, chameleonKey }
export default chameleonReducer
